import { ZfDialog, ZfDialogContent, ZfDialogFooter, ZfDialogHeader, ZfStack, ZfTextButton } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
    isOpen: boolean;
    onClose: () => void;
    onDelete: () => void;
}

export const ConfirmDeleteModal: FunctionComponent<IProps> = ({ isOpen, onClose, onDelete }) => {
    const { t } = useTranslation();

    return (
        <ZfDialog show={isOpen} showCloseButton={true} onDialogClose={onClose} size="s" className="event-modal-confirmation">
            <ZfDialogHeader>{t('modalConfirmDeleteTitle')}</ZfDialogHeader>
            <ZfDialogContent>
                <span>{t('modalConfirmDeleteText')}</span>
            </ZfDialogContent>
            <ZfDialogFooter>
                <ZfStack slot="primary" direction="row" spacing="extra-small">
                    <ZfTextButton size="medium" hierarchy="tertiary" onClick={onClose}>
                        {t('cancel')}
                    </ZfTextButton>
                    <ZfTextButton size="medium" hierarchy="primary" kind="destructive" onClick={onDelete}>
                        {t('modalDeleteButton')}
                    </ZfTextButton>
                </ZfStack>
            </ZfDialogFooter>
        </ZfDialog>
    );
};
